export const FEEDBACK_VALUES = {
  NEGATIVE: -1,
  NEUTRAL: 0,
  POSITIVE: 1,
} as const;

export type FeedbackValuesType = typeof FEEDBACK_VALUES;
export type FeedbackValue = FeedbackValuesType[keyof FeedbackValuesType];

export const ROLE_VALUES = {
  SYSTEM: "system",
  ASSISTANT: "assistant",
  USER: "user",
} as const;

export type RoleValuesType = typeof ROLE_VALUES;
export type RoleType = RoleValuesType[keyof RoleValuesType];

export const DEFAULT_CONVERSATIONS_LIMIT = 20;

import type { GetConversationHistoryApiConversationsGetData } from "./generated";

export type ConversationSortOption = "new-old" | "old-new" | "az" | "za";

export type FetchConversationsParams = NonNullable<GetConversationHistoryApiConversationsGetData["query"]> & {
  filter?: string;
  sort?: ConversationSortOption;
};
